import { defineComponent, toRef, Ref } from 'vue';
import { setupComponent } from '@studyportals/vue-platform';
import ScoreGradientCircle from './ScoreGradientCircle.CB';

export default defineComponent({
	props: {
		score: Number,
	},
	setup: (props) => {
		const score = toRef(props, 'score') as Ref<number>;
		const codeBehind = new ScoreGradientCircle(score);

		return setupComponent(codeBehind);
	},
});
